import { createContext, useContext } from 'react';

import { useMutation } from '@tanstack/react-query';

import { noop } from '@utils/browser';

import { AiChatProps, ChatMessage, NewAiChatProps, NewChatMessage } from './types';

const AiInputAssistContext = createContext<AiAssistInputContextProps>({
  newChat: noop as any,
  sendChatMessage: noop as any,
});

const useAiInputAssistApi = () => {
  return useContext(AiInputAssistContext);
};

type AiAssistInputContextProps = {
  newChat: (props: NewAiChatProps) => Promise<NewChatMessage>;
  sendChatMessage(props: AiChatProps): Promise<ChatMessage>;
};

export const AiInputAssistProvider: React.FC<AiAssistInputContextProps> = ({
  children,
  ...rest
}) => {
  return <AiInputAssistContext.Provider value={rest} children={children} />;
};

export const useAiInputAssistSendMessage = () => {
  const { sendChatMessage } = useAiInputAssistApi();

  return useMutation({
    mutationFn: (props: AiChatProps) => sendChatMessage(props),
  });
};

export const useAiInputAssistCreateNewChat = () => {
  const { newChat } = useAiInputAssistApi();

  return useMutation({
    mutationFn: (props: NewAiChatProps) => newChat(props),
  });
};
